import React, {
  useState,
  useEffect,
  useCallback,
  ButtonHTMLAttributes,
} from 'react';
import { useLocation } from 'react-router-dom';

import { Accordion, Checkbox, Modal } from '../../components';
import api from '../../services/api';
import {
  isScreenInstructionRead,
  markScreenInstructionsAsRead,
  markScreenInstructionsAsUnread,
} from '../../services/instructions';
import { hash } from '../../utils/hashGenerator';

interface InstructionProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void;
}

export const InstructionModal = ({ onClick, ...rest }: InstructionProps) => {
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(true);
  const [isChecked, setsIsChecked] = useState<boolean>(true);
  const [dataInstruction, setdataInstruction] = useState<any>([]);
  let url_atual = window.location.pathname;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [pathLocation, setPathLocation] = useState<string>('');
  const location = useLocation();
  let [pageId, setPageId] = useState<string>('');

  useEffect(() => {
    setPathLocation(location.pathname);
    getScreenId();
  }, [location.pathname]);

  const openModal = () => {
    setShowDeleteModal(true);
  };

  const closeModal = () => {
    setShowDeleteModal(false);
  };

  async function getScreenId() {
    try {
      const screens = await fetchDataScreen();
      if (!Array.isArray(screens)) {
        return;
      }
      for (const item of screens) {
        const screenUrl = item?.url;
        const screenId = item?.id;
        if (screenUrl === undefined || screenId === undefined) {
          continue;
        }
        if (url_atual === screenUrl) {
          setPageId(screenId);
          showInstructions(screenId);
        }
      }
    } catch (err) {
      console.log('Erro', err);
    }
  }

  const fetchData = useCallback(async () => {
    try {
      const response = await api.get('/instrucao');
      const payload = response.data;
      return Array.isArray(payload) ? payload : [];
    } catch (err) {
      console.log(err);
      return [];
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const fetchDataScreen = useCallback(async () => {
    try {
      const response = await api.get('/tela');
      const payload = response.data;
      return Array.isArray(payload) ? payload : [];
    } catch (err) {
      console.log(err);
      return [];
    }
  }, []);

  useEffect(() => {
    fetchDataScreen();
  }, [fetchDataScreen]);

  async function findInstructions(pageId: string) {
    const instructions = await fetchData();
    filterInstructionforScreen(instructions, pageId);
    openModal();
  }

  function showInstructions(pageId: string) {
    if (pageId) {
      let isChecked = isScreenInstructionRead(pageId);
      setsIsChecked(isChecked);
      if (!isChecked) {
        findInstructions(pageId);
      }
    }
  }

  function filterInstructionforScreen(instructions: unknown[], pageId: string) {
    const screenInstruction = instructions.filter((item: any) => {
      const telas = item?.listaDeTelas;
      return Array.isArray(telas) && telas.includes(pageId);
    });
    setdataInstruction(screenInstruction);
  }

  async function handleChecked(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.checked) {
      markScreenInstructionsAsRead(pageId);
    } else {
      markScreenInstructionsAsUnread(pageId);
    }
  }

  return (
    <>
      {isChecked ? null : (
        <Modal
          id={'ModalDeInstrucoes'}
          show={dataInstruction.length && showDeleteModal}
          titulo={'Instruções sobre esta página'}
          onCancel={() => closeModal()}
          bodyBottom={
            <>
              <Checkbox
                label="Não mostrar novamente."
                value={'valor'}
                onChange={e => handleChecked(e)}
              />
            </>
          }
        >
          {dataInstruction.map((data: any, index: number) => (
            <Accordion
              id={hash(data.id)}
              key={hash(data.id)}
              title={data.nomeDaInstrucao}
              description={data.textoDaInstrucao}
            />
          ))}
        </Modal>
      )}
    </>
  );
};
